import { useSelector } from "react-redux";
import { RootState } from "../store/rootReducer";

const NavigationUser = () => {
  const authorizedUser =  useSelector((state: RootState) => state.authorization.authorizedUser);
  
  if (!authorizedUser) return null;

  return (
    <div className="user-panel">
      <div className="pull-left image">
        <img src="/images/blank-user.png" className="img-circle" alt="User Image" />
      </div>
      <div className="pull-left info">
        <div>{ authorizedUser.NIK_DETAIL.EMP_NAME }</div>
        <div style={{ marginTop: '5px', color: '#7c7c7c' }}>{ authorizedUser.NIK_DETAIL.EMP_JABATAN }</div>
      </div>
    </div>
  );
}

export default NavigationUser;